import {i} from "core/localization/localization";

let targetTypes;

export function getTargetTypes(){
	if(!targetTypes){
		targetTypes = Object.freeze({
			ASSET: i('Asset'),
			ASSET_GROUP: i('Asset Group')
		})
	}

	return targetTypes;
}
